import {ROUTE_PATH} from 'constants/routes';
import {NotAuthRoute} from 'utils/routes';

import {LoginPage} from './LoginPage';
import {ForgotPasswordPage, ResetPasswordPage} from './Password';
import {ConfirmCreateUserPage, ConfirmProspectPage} from './Registration';

type Props = {
    onSuccessLogin: () => void;
}

export const getPublicRoutes = ({onSuccessLogin}: Props) => ([
    <NotAuthRoute
        key='login'
        path={ROUTE_PATH.PUBLIC.LOGIN}
        render={(props) => <LoginPage {...props} onSuccessLogin={onSuccessLogin} />}
    />,
    <NotAuthRoute key='forgot-password' path={ROUTE_PATH.PUBLIC.PASSWORD.FORGOT} component={ForgotPasswordPage} />,
    <NotAuthRoute key='reset-password' path={ROUTE_PATH.PUBLIC.PASSWORD.RESET} component={ResetPasswordPage} />,
    <NotAuthRoute key='create-user' path={ROUTE_PATH.PUBLIC.CONFIRM.CREATE_USER} component={ConfirmCreateUserPage} />,
    <NotAuthRoute key='confirm-prospect' path={ROUTE_PATH.PUBLIC.PROSPECT.CONFIRM} component={ConfirmProspectPage} />
]);
